import React, { useEffect } from 'react';
import { Partners } from './Partners'; // Asegúrate de que la ruta sea correcta

export const About = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const valores = [
    { t: "Innovación", d: "Exploramos nuevas fronteras tecnológicas." },
    { t: "Excelencia", d: "Calidad superior en cada entrega." },
    { t: "Ética", d: "Integridad y transparencia total." },
    { t: "Colaboración", d: "Crecemos junto a nuestros aliados." }
  ];

  return (
    // He cambiado pt-20 a pt-32 para que el Navbar no tape el contenido
    <section className="bg-white pt-32 overflow-hidden">
      
      {/* Hero de Quiénes Somos */}
      <div className="max-w-7xl mx-auto px-6 pb-20 flex flex-col lg:flex-row items-center gap-12">
        <div className="lg:w-1/2">
          {/* Eliminé text-outline para evitar errores de CSS, usé font-black */}
          <h1 className="text-5xl md:text-8xl font-black text-every-blue mb-6 uppercase leading-tight">
            ¿Quiénes <br />
            <span className="text-every-gold">Somos?</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 font-light leading-relaxed">
            En <span className="font-bold text-every-blue">Every Technology SAS</span>, somos una firma especializada en consultoría e innovación tecnológica, dedicada a convertir desafíos complejos en soluciones estratégicas.
          </p>
        </div>
        
        {/* Cuadro de impacto visual */}
        <div className="lg:w-1/2 p-10 md:p-16 bg-every-blue rounded-[3rem] text-white shadow-2xl relative">
          <p className="text-3xl md:text-4xl italic font-serif relative z-10 leading-snug">
            "Tu próximo aliado estratégico en innovación y crecimiento digital."
          </p>
          {/* Un detalle decorativo para que no se vea plano */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-every-gold/10 rounded-full -mr-10 -mt-10 blur-3xl"></div>
        </div>
      </div>

      {/* Misión y Visión */}
      <div className="bg-gray-50 py-24 px-6 border-y border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16">
          <div className="space-y-6 border-l-4 border-every-gold pl-8">
            <h2 className="text-every-gold font-bold uppercase tracking-[0.3em] text-sm">Nuestra Misión</h2>
            <p className="text-2xl text-every-blue leading-relaxed font-medium">
              Impulsar la transformación de empresas a través de soluciones tecnológicas vanguardistas, acompañándolas en cada etapa de su evolución digital.
            </p>
          </div>
          <div className="space-y-6 border-l-4 border-every-gold pl-8">
            <h2 className="text-every-gold font-bold uppercase tracking-[0.3em] text-sm">Nuestra Visión</h2>
            <p className="text-2xl text-every-blue leading-relaxed font-medium">
              Ser reconocidos globalmente como líderes en consultoría tecnológica, destacando por nuestra capacidad de innovar y generar valor sostenible.
            </p>
          </div>
        </div>
      </div>

      {/* Valores Corporativos */}
      <div className="py-24 px-6 max-w-7xl mx-auto">
        <h3 className="text-center text-4xl font-black text-every-blue mb-16 uppercase tracking-tighter">Valores Corporativos</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {valores.map((v, i) => (
            <div key={i} className="group text-center p-10 border border-gray-100 rounded-3xl hover:bg-every-blue hover:scale-105 transition-all duration-500 shadow-sm hover:shadow-xl">
              <h4 className="text-every-gold font-bold text-xl mb-3 group-hover:text-white">{v.t}</h4>
              <p className="text-gray-500 text-sm group-hover:text-gray-300 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Información Legal y Corporativa */}
      <div className="bg-gray-50 py-24 px-6 border-t border-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h3 className="text-xs font-bold text-every-gold uppercase tracking-[0.3em] mb-3">Transparencia y Respaldo</h3>
            <h4 className="text-3xl md:text-5xl font-black text-every-blue uppercase tracking-tight">Información Corporativa</h4>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Razón Social */}
            <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-lg flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-2xl bg-every-blue/5 text-every-blue flex items-center justify-center mb-6">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <p className="text-xs uppercase tracking-widest font-bold text-gray-400 mb-2">Razón Social</p>
                <h5 className="text-xl font-black text-every-blue leading-tight">EVERY TECHNOLOGY S.A.S.</h5>
              </div>
              <p className="text-xs text-gray-500 mt-6 pt-4 border-t border-gray-100">Sociedad por Acciones Simplificada</p>
            </div>

            {/* Identificación Tributaria (NIT) */}
            <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-lg flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-2xl bg-every-gold/10 text-every-gold flex items-center justify-center mb-6">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-xs uppercase tracking-widest font-bold text-gray-400 mb-2">Identificación Tributaria</p>
                <h5 className="text-2xl font-black text-every-blue leading-tight">NIT 901930925-6</h5>
              </div>
              <p className="text-xs text-gray-500 mt-6 pt-4 border-t border-gray-100">Registrada ante la Dirección de Impuestos y Aduanas</p>
            </div>

            {/* Representante Legal */}
            <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-lg flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 rounded-2xl bg-every-blue/5 text-every-blue flex items-center justify-center mb-6">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <p className="text-xs uppercase tracking-widest font-bold text-gray-400 mb-2">Representación Legal</p>
                <h5 className="text-xl font-black text-every-blue leading-tight">Lorena Ramírez Payares</h5>
                <p className="text-sm font-semibold text-every-gold mt-1">C.C. 1.003.376.970</p>
              </div>
              <p className="text-xs text-gray-500 mt-6 pt-4 border-t border-gray-100">Representante Legal Principal</p>
            </div>
          </div>
        </div>
      </div>

      {/* Re-incorporación de Aliados (Partners) */}
      <div className="bg-white py-20 border-t border-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <p className="text-center text-gray-400 font-bold uppercase tracking-widest text-[10px] mb-12">Empresas que confían en nosotros</p>
          <Partners />
        </div>
      </div>

    </section>
  );
};